import "./RedirectPage.scss";
import raindrop from "../../images/redirect-waterdrop.png";
import { RedirectingAnimation } from "./RedirectingAnimation";
import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Config from "../../config/Config";

export const RedirectPage = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            // can set behavior for redirecting here
            navigate(`${Config.appUrl}/welcome`); // Default fallback route
        }, 5000); // update this if we want it faster

        // Cleanup function to clear timeout if component unmounts
        return () => {
            clearTimeout(timeoutId);
        };
    }, [navigate, searchParams]);

    return (
        <div className="redirect-page flex-column-center pt-1">
            <h1>Uh-oh... we may have taken a wrong turn!</h1>
            <div className="img-wrapper width-30rem height-auto">
                <img
                    className="width-100 height-auto"
                    src={raindrop}
                    alt="Redirect Page Illustration"
                />
            </div>
            <RedirectingAnimation />
            <h2>Let's get you back to where you need to be.</h2>
        </div>
    );
}